import { Box, Collapse, Divider, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import Iconify from "../../components/iconify/Iconify";
import { formatCurrency } from "../../utils/currency";

const AddonSummary = ({ addons = [], itemPrice, itemQty }) => {
  const [open, setOpen] = useState(false);

  if (!addons.length) return null;

  if (!addons.length) return null;

  const addonCount = addons.reduce((sum, a) => sum + (a.qty || 1), 0);
  const addonsTotal = addons.reduce(
    (sum, a) => sum + a.price * (a.qty || 1),
    0
  );

  const itemBaseTotal = itemPrice * itemQty;
  const finalItemTotal = itemBaseTotal + addonsTotal;

  return (
    <Box sx={{ ml: 5, mr: 3 }}>
      <Box
        onClick={() => setOpen((o) => !o)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          cursor: "pointer",
          userSelect: "none",
          color: "#1976d2",
        }}
      >
        <Typography
          variant="caption"
          fontWeight={500}
          sx={{
            fontSize: 12,
          }}
        >
          + {addonCount} Add-ons ({formatCurrency(addonsTotal)})
        </Typography>
      </Box>

      {/* Add-on Details */}
      <Collapse in={open} timeout={180} unmountOnExit>
        <Box
          sx={{
            mt: 0.75,
            ml: 2,
            pl: 1,
          }}
        >
          {addons.map((addon, index) => (
            <Box
              key={addon.addon_uid}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: 12,
                color: "text.secondary",
                lineHeight: 1.6,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                <Iconify
                  icon="mdi:subdirectory-arrow-right"
                  width={14}
                  color="#9ca3af"
                />
                <span>
                  {addon.addon_name} × {addon.qty}
                </span>
              </Box>

              <span>₹{addon.price * addon.qty}</span>
            </Box>
          ))}

          {/* Dashed Total Row */}
          <Divider
            sx={{
              borderStyle: "dashed",
              mt: 1,
              mb: 0.5,
            }}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 13,
              fontWeight: 600,
              mb: 0.5,
            }}
          >
            <Typography
              variant="body2"
              style={{
                fontWeight: 600,
              }}
            >
              Total
            </Typography>
            <Typography
              variant="body2"
              style={{
                fontWeight: 600,
              }}
            >
              {formatCurrency(finalItemTotal)}
            </Typography>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};

export default AddonSummary;
